[
  [
    13,
    6
  ],
  [
    11,
    2
  ],
  [
    11,
    2
  ],
  [
    11,
    2
  ],
  [
    11,
    2
  ],
  [
    11,
    2
  ],
  [
    11,
    2
  ],
  [
    11,
    2
  ],
  [
    11,
    2
  ],
  [
    11,
    2
  ],
  [
    284,
    80
  ],
  [
    286,
    80
  ],
  [
    134,
    85
  ],
  [
    134,
    96
  ],
  [
    194,
    158
  ],
  [
    194,
    158
  ],
  [
    194,
    158
  ],
  [
    194,
    158
  ],
  [
    180,
    153
  ],
  [
    201,
    178
  ],
  [
    309,
    209
  ],
  [
    207,
    401
  ],
  [
    106,
    219
  ],
  [
    53,
    248
  ],
  [
    291,
    64
  ]
]